import React from 'react';
import '../Estilos/Tabela.css';
import IconeMenu from './IconeMenu';

const TabelaComponente = ({
  colunas,
  campos,
  linhas,
  total,
  paginaAtual,
  aviso,
  menuOptions,
  onEditClick,
  onMenuToggle = null,
  onMenuItemSelect,
  goToPreviousPage,
  goToNextPage,
  entity,
  role,
  actions = true,
}) => {

  const { useTranslation } = require('react-i18next');
  const { t: tRoles } = useTranslation('roles');

  const getRowClass = (item) => {
    if (item.status === 'OK') {
      return 'Linha OK';
    } else if (item.status === 'NG') {
      return 'Linha NG';
    }
    return 'Linha PADRAO';
  };

  const itemsPerPage = 10;
  const totalPages = Math.ceil(total / itemsPerPage);

  const firstItemIndex = paginaAtual * itemsPerPage + 1;
  const lastItemIndex = Math.min(firstItemIndex + itemsPerPage - 1, total);

  return (
    <div className="ContainerTabela">
      <table className={`View ${entity}`} width="100%">
        <thead>
          <tr className="Tabela">
            {colunas.map((coluna, index) => (
              <th key={index} className="Tabela">
                {coluna}
              </th>
            ))}
            {actions && <th>AÇÕES</th>}
          </tr>
        </thead>
        <tbody>
          {linhas.length === 0 ? (
            <tr>
              <td colSpan={colunas.length + 1} className="TabelaAviso">
                <div style={{ textAlign: 'center', marginTop: '60px' }}>{aviso}</div>
              </td>
            </tr>
          ) : (
            linhas.map((item, index) => (
              <tr key={index} className={getRowClass(item)}>
                {campos.map((campo, campoIndex) => {
                  if (campo === 'disabled' && typeof item[campo] === 'boolean') {
                    return (
                      <td
                        key={campoIndex}
                        className={item[campo] ? 'Linha INATIVO' : 'Linha ATIVO'}
                      >
                        {item[campo] ? 'INATIVO' : 'ATIVO'}
                      </td>
                    );
                  } else if (campo === 'calibrationStatus') {
                    return (
                      <td key={campoIndex} className={item[campo] === 'CALIBRATED' ? 'Linha OK' : 'Linha NG'}>
                        {item[campo] === 'CALIBRATED' ? 'ATIVO' : 'EM CALIBRAÇÃO'}
                      </td>
                    );
                  } else if (campo === 'role') {
                    return (
                      <td key={campoIndex} className={getRowClass(item)}>
                        {tRoles(item[campo])}
                      </td>
                    );
                  } else if (
                    campo === 'user.name' &&
                    item.hasOwnProperty('user') &&
                    item.user.hasOwnProperty('name')
                  ) {
                    return (
                      <td key={campoIndex} className={getRowClass(item)} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {item.user.name}
                      </td>
                    );
                  } else if (
                    campo === 'environment.name' &&
                    item.hasOwnProperty('environment') &&
                    item.environment.hasOwnProperty('name')
                  ) {
                    return (
                      <td key={campoIndex} className={getRowClass(item)} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {item.environment.name}
                      </td>
                    );
                  } else if (
                    campo === 'endnode.endnodeIdentification' &&
                    item.hasOwnProperty('endnode') &&
                    item.endnode.hasOwnProperty('endnodeIdentification')
                  ) {
                    return (
                      <td key={campoIndex} className={getRowClass(item)} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {item.endnode.endnodeIdentification}
                      </td>
                    );
                  } else {
                    return (
                      <td key={campoIndex} className={getRowClass(item)} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {item[campo]}
                      </td>
                    );
                  }
                })}
                {actions && (
                  <td className="Acoes">
                    <IconeMenu
                      id={item.id}
                      entity={entity}
                      type={entity}
                      menuOptions={menuOptions}
                      onEditClick={() => onEditClick(item.id)}
                      onMenuToggle={(id, isVisible) =>
                        onMenuToggle ? onMenuToggle(id, isVisible) : null
                      }
                      onMenuItemSelect={(id, menuItem) => onMenuItemSelect(id, menuItem)}
                      role={role}
                    />
                  </td>
                )}
              </tr>
            ))
          )}
        </tbody>
      </table>
      <div className="FooterTabela">
        <span>{`${firstItemIndex}-${lastItemIndex} de ${total}`}</span>
        <button
          className="next-button"
          onClick={goToPreviousPage}
          disabled={total === 0 || paginaAtual === 0}
        ></button>
        <button
          className="previous-button"
          onClick={goToNextPage}
          disabled={total === 0 || paginaAtual === totalPages - 1}
        ></button>
      </div>
    </div>
  );
};

export default TabelaComponente;
